<template>
  <div :class="$options.name">
    <el-dialog :visible="dialogVisible" top="80px" width="1200px" :before-close="handleClose" :close-on-click-modal="false"
      :modal="false">
      <el-form ref="option" :model="option" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="裁剪宽高比">
              <el-select v-model="proportion" @change="getproportion" placeholder="请选择裁剪比例" style="width: 100%;">
                <el-option v-for="item in proportionlist" :key="item.value" :label="item.label" :value="item.value">
                  <span style="float: left">{{ item.label }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="固定宽高比">
              <el-switch v-model="option.fixed" active-color="#13ce66" inactive-color="#ff4949">
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="option.fixed">
            <el-form-item label="宽 : 高">
              <el-input-number v-model="option.autoCropWidth" :min="20" :max="4000" placeholder="宽度" size="small" style="width: 120px;" @change="updateFixedNumber" />
              <span style="margin: 0 8px;">:</span>
              <el-input-number v-model="option.autoCropHeight" :min="20" :max="4000" placeholder="高度" size="small" style="width: 120px;" @change="updateFixedNumber" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="cropper-container">
        <div class="cropper-el">
          <vue-cropper ref="cropper" :img="cropperImg" :output-size="option.size" :output-type="option.outputType"
            :info="true" :full="option.full" :can-move="option.canMove" :can-move-box="option.canMoveBox"
            :fixed-box="option.fixedBox" :original="option.original" :auto-crop="option.autoCrop"
            :auto-crop-width="option.autoCropWidth" :auto-crop-height="option.autoCropHeight"
            :center-box="option.centerBox" :high="option.high" :info-true="option.infoTrue" @realTime="realTime"
            :enlarge="option.enlarge" :fixed="option.fixed" :fixed-number="option.fixedNumber" />
        </div>
        <!-- 预览 -->
        <div class="prive-el">
          <div class="prive-style" :style="{
            overflow: 'hidden',
            margin: '0 25px',
            display: 'flex',
            'align-items': 'center',
          }">
            <div class="preview" :style="previews.div">
              <img :src="previews.url" :style="previews.img" />
            </div>
          </div>
          <el-button @click="uploadBth" v-if="option.img">重新上传</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="saveImg">裁剪上传</el-button>
        <el-button type="primary" @click="saveImg2">不裁剪上传</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { VueCropper } from "vue-cropper";
import axios from "axios";
export default {
  name: "Cropper",
  components: {
    VueCropper,
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    imgType: {
      type: String,
      default: "blob",
    },
    cropperImg: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      proportionlist: [
        {
          label: "轮播图",
          value: "300*150",
        },
        {
          label: "产品图",
          value: "150*150",
        },
      ],
      proportion: null,
      previews: {},
      option: {
        img: "", // 裁剪图片的地址
        size: 1, // 裁剪生成图片的质量
        full: false, // 是否输出原图比例的截图 默认false
        outputType: "jpg", // 裁剪生成图片的格式 默认jpg
        canMove: true, // 上传图片是否可以移动
        fixedBox: false, // 固定截图框大小 不允许改变
        original: true, // 上传图片按照原始比例渲染
        canMoveBox: true, // 截图框能否拖动
        autoCrop: true, // 是否默认生成截图框
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 200, // 默认生成截图框宽度
        autoCropHeight: 150, // 默认生成截图框高度
        centerBox: false, // 截图框是否被限制在图片里面
        high: false, // 是否按照设备的dpr 输出等比例图片
        enlarge: 1, // 图片根据截图框输出比例倍数
        mode: "contain", // 图片默认渲染方式
        maxImgSize: 4000, // 限制图片最大宽度和高度
        limitMinSize: [20, 20], // 更新裁剪框最小属性
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        fixed: false, // 是否开启截图框宽高固定比例  (默认:false)
        fixedNumber: [9, 16], // 截图框的宽高比例
      },
    };
  },
  methods: {
    // 选择裁剪比例
    getproportion(value) {
      console.log(value);
      let arr = value.split("*");
      this.option.autoCropWidth = Number(arr[0]);
      this.option.autoCropHeight = Number(arr[1]);
      this.updateFixedNumber();
    },
    // 更新固定宽高比
    updateFixedNumber() {
      if (this.option.autoCropWidth && this.option.autoCropHeight) {
        // 计算最大公约数
        const gcd = (a, b) => b === 0 ? a : gcd(b, a % b);
        const commonDivisor = gcd(this.option.autoCropWidth, this.option.autoCropHeight);
        this.option.fixedNumber = [this.option.autoCropWidth / commonDivisor, this.option.autoCropHeight / commonDivisor];
      }
    },
    // 裁剪时触发的方法，用于实时预览
    realTime(data) {
      this.previews = data;
    },
    // 重新上传
    uploadBth() {
      this.$emit("update-cropper");
    },
    // 取消关闭弹框
    handleClose() {
      this.$emit("close-dialog", false);
    },
    // 获取裁剪之后的图片，默认blob，也可以获取base64的图片
    saveImg() {
      if (this.imgType === "blob") {
        this.$refs.cropper.getCropBlob((data) => {
          this.$emit("upload-img", data);
        });
      } else {
        this.$refs.cropper.getCropData((data) => {
          this.$emit("upload-img", data);
        });
      }
    },
    saveImg2() {
      this.$refs.cropper.getCropBlob((data) => {
          console.log(data,'裁剪是什么格式')
        });
      this.getblobFile({name:'测试',status:'success',uid:1221121212,url:this.cropperImg})
   
    },
    async  getblobFile(data) {
      let file = {}; const config = { responseType: 'blob' };
      const response = await axios.get(data.url, config);
      file = new window.File([response.data], data.name, { type: 'image/png' });
      console.log(file,'原图什么格式')
      this.$emit("upload-img", file);
      return file
    }
  },
};
</script>

<style lang="scss" scoped>
.Cropper {
  .cropper-el {
    height: 600px;
    width: 800px;
  }

  .cropper-container {
    display: flex;
    justify-content: space-between;

    .prive-el {
      height: 164px;
      width: 94px;
      flex: 1;
      text-align: center;

      .prive-style {
        margin: 0 auto;
        flex: 1;
        -webkit-flex: 1;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        -webkit-justify-content: center;
        overflow: hidden;
        background: #ededed;
        margin-left: 40px;
      }

      .preview {
        overflow: hidden;
      }

      .el-button {
        margin-top: 20px;
      }
    }
  }
}
</style>
